import { McIcon } from "./icon.js";

export class McIconPeople extends McIcon {
  constructor() {
    super();
    const templ = document.createElement("template");
    templ.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"  aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
`;
    super.addHTML(templ);
  }
}

if (!window.customElements.get("mc-icon-people"))
  window.customElements.define("mc-icon-people", McIconPeople);
